<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ 'TagCreator.Title' | translate }}</h2>
      <p class="subtitle">{{ 'TagCreator.Subtitle' | translate }}</p>
    </div>
    @if (dialogRef) {
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <mat-dialog-content class="form-content">
    <form class="tag-form" [formGroup]="tagForm">
      <div class="w-100 mb-3">
        <mat-label class="form-label mb-1">{{ 'TagCreator.AddLabel' | translate }}</mat-label>
        <div class="add-tag-box">
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="flex-grow-1">
            <textarea matInput formControlName="tag" [placeholder]="'TagCreator.TagPlaceholder' | translate" (keydown.enter)="!tagForm.invalid && addTag(); $event.preventDefault()"></textarea>
          </mat-form-field>
          <button mat-flat-button color="primary" class="add-btn" [disabled]="tagForm.invalid" (click)="addTag()">
            <mat-icon>add</mat-icon>
            {{ 'TagCreator.Add' | translate }}
          </button>
        </div>
      </div>

      @if (currentChunk()?.type === 'video' || currentChunk()?.type === 'audio') {
        <div class="w-100 mb-4">
          <mat-label class="form-label mb-1">{{ 'TagCreator.Timestamp' | translate }}</mat-label>
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
            <input matInput type="text" formControlName="timestamp" placeholder="hh:mm:ss" />
          </mat-form-field>
        </div>
      }
    </form>

    <div class="tags-section mt-4">
      <div class="tags-header mb-2">
        <mat-label class="form-label">{{ 'TagCreator.TagsCountLabel' | translate: { count: currentChunk()?.tags?.length || 0 } }}</mat-label>
        @if (currentChunk()?.tags?.length > 0) {
          <button matButton color="warn" (click)="removeAllTags($event)">
            {{ 'TagCreator.DeleteAll' | translate }}
          </button>
        }
      </div>

      <div class="tags-container">
        @if (currentChunk()?.tags?.length > 0) {
          <mat-chip-listbox>
            @for (tag of currentChunk().tags; track tag) {
              <mat-chip-option (removed)="removeTag(tag)" class="tag-chip">
                {{ tag.content }}
                @if (tag.timestamp) {
                  <span class="timestamp-label">({{ tag.timestamp }})</span>
                }
                <button matChipRemove>
                  <mat-icon>close</mat-icon>
                </button>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        } @else {
          <p class="empty-state">{{ 'Global.NoData' | translate }}</p>
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="left-info">
      @if (currentChunk()?.tags?.length > 0) {
        <p class="summary-text">
          {{ 'TagCreator.TagsSummary' | translate: { count: currentChunk()?.tags?.length } }}
        </p>
      }
    </div>
    <div class="right-actions">
      @if (dialogRef) {
        <button mat-flat-button color="primary" class="done-btn" (click)="dialogRef.close()">
          {{ 'Global.Done' | translate }}
        </button>
      }
    </div>
  </mat-dialog-actions>
</div>
